export default "__VITE_ASSET__DifUR8Hu__"